<template>
  <div style="width: 100%;min-height: 600px;" v-loading="loading">
    <iframe :src="url" frameborder="0" width="100%" :height="height+'px'" id="iframe_loading"></iframe>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <el-input placeholder="请输入网址" v-model="urls" @keyup.enter.native="open()">
        <el-select v-model="select" slot="prepend" placeholder="请选择内容" style="width: 90px;">
          <el-option label="http://" value="http://"></el-option>
          <el-option label="https://" value="https://"></el-option>
        </el-select>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="open()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
export default {
  props: {
      url: {
        type: String,
        default: ''
      },
    },
  data () {
    return {
      //用户相关信息
      //url:'',
      height:600,
      loading:false,
      dialogVisible: false,
      select:'http://',
      urls:'',
    }
  },
  created() {
    //
    this.height=document.body.clientHeight-150;
  },
  //页面开启时执行
  mounted(){
    //this.open();
    this.getLoading()
  },
  //方法
  methods: {
    //加载进度
    getLoading(){
      this.loading=true;
      var iframe = document.getElementById("iframe_loading");
      if (iframe.attachEvent){ // 兼容IE写法
      	iframe.attachEvent("onload", function(){
      		// iframe加载完成后要进行的操作
          this.$message({
            message: '正在加载，请稍后！',
            type: 'info'
          });
      	})
      } else {
      	iframe.onload=this.if_onload();
        // iframe加载完成后要进行的操作
      }
    },
    if_onload(){
      this.$message({
        message: '正在加载，请稍后！',
        type: 'info'
      });
      setTimeout(() => {
        this.loading=false;
      },2000)
    },
    open(){
      this.url=this.select+this.urls;
      this.dialogVisible=false;
      this.getLoading();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            this.url="https://www.baidu.com"
            this.dialogVisible=false;
            done();
          })
          .catch(_ => {});
      }
  }
}
</script>

<style scoped>
  #bodys{
    width: 767px;
    min-height: 800px;
    overflow: hidden;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/A_zujian/IframeVue.vue